import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';
import {
  SET_BILLING_MONTHS,
  SET_PRICING_PLAN,
  SET_BILLING_PLAN,
  SET_CREDIT_CARDS,
  SET_BILLING_SETTINGS
} from './mutationTypes';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  
  [SET_BILLING_MONTHS](state, response) {
    state.billingMonths = response;
  },

  [SET_PRICING_PLAN](state, response) {
    state.pricingPlan = response;
  },

  [SET_BILLING_PLAN](state, response) {
    state.billingPlan = response;
  },

  [SET_CREDIT_CARDS](state, response) {
    state.creditCards = response;
  },

  [SET_BILLING_SETTINGS](state, response) {
    state.billingPlan.billingSettings = response;
  },
};

